// Components
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { CloseIcon } from "../../../assets/icons";

const DefaultModal = ({
  isOpen,
  onClose,
  fullScreen,
  maxWidth = "sm",
  title,
  children,
  modalActions,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={maxWidth}
    >
      <DialogTitle
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="#202338"
        color="#FFF"
      >
        <Typography fontWeight={600} fontSize="20px">
          {title}
        </Typography>
        <IconButton aria-label="close-modal" onClick={onClose}>
          <CloseIcon color="#FFF" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>{children}</DialogContent>
      {modalActions && (
        <DialogActions
          sx={{ padding: "20px", borderTop: "1px solid #435B6D7A" }}
        >
          {modalActions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DefaultModal;
